/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для юридических лиц.
   */
  app.LegalEntityListView = app.View.extend({
    el: '#legal-entity-list',
    legalEntity: '.legal-entity',
    jsonLegalEntities: '#json-legal-entities',
    jsonCounterparties: '#json-counterparties',
    countEntitiesElementId: '#count-entities',
    templateId: '#legal-entities-view',
    additionalOptions: ['faderView', 'bodyView', 'isMobile'],
    // Обработчики пользовательских событий
    events: {
      'click #add-legal-entity': 'add',
      'click .js-opener-legal-entity-list': 'openOptionsMenu',
      'click .btn-act-of-reconciliation': 'openActOfReconciliationPopup',
      'click .js-btn-refund': 'handleOpenRefundPopup',
    },
    FOREIGN_COUNTERPARTY_TYPE: 4,

    /** @inheritDoc */
    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate(this.templateId);
      this.legalEntities = new app.LegalEntities();
      this.legalEntities.reset(app.helpers.TemplateHelper.getJson(this.jsonLegalEntities));
      this.counterparties = new app.Counterparties();
      this.counterparties.reset(app.helpers.TemplateHelper.getJson(this.jsonCounterparties));

      this.setViewsForLegalEntities();
      this.setViewsForCounterparties();

      this.legalEntityFormView = new app.LegalEntityFormView({
        owner: this,
        settlement: this.settlement,
      });

      var hasForeignCounterparty = _.some(this.counterparties.models, function(counterparty) {
        return counterparty.get('refund_form_type') === this.FOREIGN_COUNTERPARTY_TYPE;
      }.bind(this));
      var hasNonForeignCounterparty = _.some(this.counterparties.models, function(counterparty) {
        return counterparty.get('refund_form_type') !== this.FOREIGN_COUNTERPARTY_TYPE;
      }.bind(this));
      if (hasNonForeignCounterparty) {
        this.childViews.refundPopupView = new app.RefundPopupView({
          bodyView: this.bodyView,
          counterparties: this.counterparties,
          userPhone: this.user && this.user.get('phone'),
          userId: this.user && this.user.get('id'),
          model: new app.RefundModel(),
          fader: this.faderView,
          isMobile: this.isMobile,
        });
        this.listenTo(this.childViews.refundPopupView, 'open-another-form', this.openAnotherCounterpartyForm);
      }
      if (hasForeignCounterparty) {
        this.childViews.foreignRefundPopupView = new app.SimpleRefundPopupFormView({
          el: $('.request-refund-popup'),
          counterparties: this.counterparties,
          user: this.user,
          fader: this.faderView,
          isMobile: this.isMobile,
          bodyView: this.bodyView,
          preSelect: true, // список контрагентов уже есть на странице, попап рендерится с уже выбранным контрагентом
        });
      }

      if (this.$('.btn-act-of-reconciliation').length) {
        var collection = new app.Collection();
        collection.add(this.legalEntities.models);
        collection.add(this.counterparties.models);
        this.childViews.actOfReconciliation = new app.ActOfReconciliationView({
          opener: this.$('.btn-act-of-reconciliation'),
          collection: collection,
          faderView: this.faderView,
          userId: this.user.id ? this.user.id : '',
          bodyView: this.bodyView,
          isMobile: Boolean(this.isMobile),
        });
      }

      if (app.isMobile) {
        this.childViews.popupLegalEntity = new app.PopupLegalEntityControlsView({
          owner: this,
          collection: collection,
        });
        this.listenTo(this.childViews.popupLegalEntity, 'open-refund-popup', this.handleOpenRefundPopup);
      }

      this.listenTo(this.legalEntities, 'sync remove', this.updateList);
      this.listenTo(this.counterparties, 'sync remove', this.updateList);
      this.listenTo(this.legalEntities, 'add', this.onCreateLegalEntity);
      this.listenTo(this.counterparties, 'add', this.onCreateLegalEntity);
      Backbone.on('removeLegalEntity', this.removeLegalEntity, this);
      Backbone.on('cancelRemoveLegalEntity', this.cancelRemoveLegalEntity, this);
    },

    /**
     * Открывает форму возврата на "другую" организацию.
     * @param {number} counterpartyId - идентификатор текущего контрагента.
     */
    openAnotherCounterpartyForm: function (counterpartyId) {
      if (!this.childViews.anotherCounterpartyRefundFormView) {
        this.childViews.anotherCounterpartyRefundFormView = new app.SimpleRefundPopupFormView({
          el: $('.request-refund-popup'),
          counterparties: [],
          user: this.user,
          fader: this.faderView,
          isMobile: this.isMobile,
          bodyView: this.bodyView,
        });
      }
      this.listenToOnce(
        this.childViews.anotherCounterpartyRefundFormView,
        'step-back',
        this.handleOpenRefundPopup
      );
      this.childViews.anotherCounterpartyRefundFormView.renderCounterpartySelect();
      this.childViews.anotherCounterpartyRefundFormView.renderForm(null, counterpartyId, true);
      this.childViews.anotherCounterpartyRefundFormView.popup.open();
    },

    /**
     * Добавление элемента в список
     */
    add: function () {
      this.toggle();
      this.legalEntityFormView.render();
    },

    /**
     * Добавляет созданную модель в коллекцию дочернего вида попапа настроек.
     * @param {app.Model} model Созданная модель.
     */
    onCreateLegalEntity: function (model) {
      if (this.childViews.popupLegalEntity) {
        this.childViews.popupLegalEntity.collection.add(model);
      }
    },

    /**
     * Обновляет список физических/юридических лиц и контрагентов в личном кабинете.
     */
    updateList: function () {
      this.$el.find('.list').html(
        this.template({
          legalEntities: this.legalEntities.models,
          counterparties: this.counterparties.models,
        })
      );

      this.$(this.countEntitiesElementId).text(this.legalEntities.length + this.counterparties.length);
      this.setViewsForLegalEntities();
      this.setViewsForCounterparties();
    },

    /**
     * Создает View для контрагентов в личном кабинете.
     */
    setViewsForLegalEntities: function () {
      var self = this;

      this.$legalEntities = this.$('.legal-entity');

      // создаём экземпляр View для каждого LegalEntity
      this.$legalEntities.each(function () {
        new app.LegalEntityView({
          el: $(this),
          owner: self,
        });
      });
    },

    /**
     * Создает View для физических/юридических лиц в личном кабинете.
     */
    setViewsForCounterparties: function () {
      var self = this;

      this.$counterparties = this.$('.counterparty');

      // создаём экземпляр View для каждого Counterparty
      this.$counterparties.each(function () {
        new app.CounterpartyView({
          el: $(this),
          owner: self,
        });
      });
    },

    /**
     * Подтверждение и удаление физического/юридического лица в личном кабинете.
     */
    removeLegalEntity: function () {
      this.legalEntity = this.legalEntities.findWhere({'is_delete': true});
      if (this.legalEntity) {
        this.legalEntity.destroy();
        this.legalEntities.remove(this.legalEntity);
      } else {
        this.removeCounterparty();
      }
    },

    /**
     * Подтверждение и удаление контрагента в личном кабинете.
     */
    removeCounterparty: function () {
      this.counterparty = this.counterparties.findWhere({ is_delete: true });
      this.counterparty.save({ is_user_refused: true });
      this.counterparties.remove(this.counterparty);
    },

    /**
     * Отмена удаления физического/юридического лица в личном кабинете.
     */
    cancelRemoveLegalEntity: function () {
      this.legalEntity = this.legalEntities.findWhere({'is_delete': true});
      if (this.legalEntity) {
        this.legalEntity.unset('is_delete');
      } else {
        this.cancelRemoveCounterparty();
      }
    },

    /**
     * Отмена удаления контрагента в личном кабинете.
     */
    cancelRemoveCounterparty: function () {
      this.counterparty = this.counterparties.findWhere({'is_delete': true});
      this.counterparty.unset('is_delete');
    },

    /**
     * Открытие меню.
     * @param {Event} e
     */
    openOptionsMenu: function (e) {
      Backbone.trigger('open-action-menu-popup', e);
    },

    /**
     * Открытие попапа запроса акта сверки
     * @param {Event} e
     */
    openActOfReconciliationPopup: function (e) {
      Backbone.trigger('open-act-of-reconciliation-popup', e);
    },

    /**
     * Открытие попапа возврата денежных средств
     * @param {Event} e - событие клика по инициатору открытия.
     * @param {number} counterpartyId - идентификатор контрагента.
     */
    handleOpenRefundPopup: function (e, counterpartyId) {
      e.preventDefault();
      e.stopPropagation();
      counterpartyId = counterpartyId
        || (e.target && _.get(e.target, 'parentElement.dataset.counterpartyId', 0));
      var counterparty = this.counterparties.get(counterpartyId);
      if (counterparty) {
        var refundFormType = counterparty.get('refund_form_type');
        var refundChildViewName = 'refundPopupView';
        if (refundFormType === this.FOREIGN_COUNTERPARTY_TYPE) {
          refundChildViewName = 'foreignRefundPopupView';
        }
        if (this.childViews[refundChildViewName]) {
          this.childViews[refundChildViewName].trigger('prepare-popup', counterparty);
          this.childViews[refundChildViewName].popup.open(e);
        }
      }
    },
  });
})(jQuery);

}.call(window));